export default __webpack_public_path__ + "static/media/NH21_722_ELLE_GLORIA2055.8b0001c3.jpg";